import { GridProps } from '@mui/material';
import { IField } from 'src/types/FieldType';
// import { IRadioInfo } from 'src/types/FormControlRadioGroupProps';
import { IFields } from 'src/types/Translation';

export interface KeyValue {
  key: any;
  value: any;
}

export const formatInput = (str: string) => {
  return str.trimStart();
};

export const formatString = (str: string, ...args: KeyValue[]): string => {
  for (const k in args) {
    str = str.replace(new RegExp('\\{' + args[k].key + '\\}', 'gi'), args[k].value);
  }
  return str;
};
